import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import './serviceCard.css';
import ClearingServiceTab from './ClearingServiceTab';
import TransportServiceTab from './TransportServiceTab';
import BothServiceTab from './BothServiceTab';
import { POST } from '../../../services/rest.service';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';
import { useDispatch, useSelector } from 'react-redux';
import { showModal } from '../../../redux/error/ErrorAction';

import EmailOptVerifyModal from './EmailOptVerifyModal';
import JobSuccessModal from '../../../components/Modals/JobSuccessModal';
import 'react-phone-input-2/lib/style.css';

const ServiceCard = (props) => {
  const [activeTab, setActiveTab] = React.useState('1');
  const [token, setToken] = useState(null);
  const [values, setValues] = useState({});
  const [resetForm, setResetForm] = useState();

  // State to store the job response data - moved to top
  const [jobResponseData, setJobResponseData] = useState({});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [tooltip, setTooltip] = useState({ show: false, message: '', x: 0, y: 0 });
  const tooltipTimeoutRef = useRef(null);

  // Refs for the disabled tabs
  const transportTabRef = useRef(null);
  const bothTabRef = useRef(null);

  const dispatch = useDispatch();

  const onSubmit = async (values, resetForm, onError) => {
    setResetForm(() => resetForm);
    setValues(values);
    setIsModalOpen(true);
  };

  const onOtpVerified = () => {
    setIsModalOpen(false);
    dispatch(showLoading('Please wait...'));

    const submitValues = { ...values };

    if (submitValues.category != 1) {
      delete submitValues['type'];
    } else if (!submitValues.type) {
      delete submitValues['type'];
    }

    if (activeTab === '1') {
      submitValues.job_type = 'clearing';
    } else if (activeTab === '2') {
      submitValues.job_type = 'transport';
    } else if (activeTab === '3') {
      submitValues.job_type = 'both';
    }

    POST('/guest/job-post', submitValues)
      .then(({ data }) => {
        dispatch(hideLoading());

        const responseData = {
          jobId: data?.data?.jobId || data?.jobId || null,
          jobUUID: data?.data?.jobUUID || data?.jobUUID || null,
          jobType: data?.data?.jobType || data?.jobType || null,
          email: data?.data?.email || data?.email || null,
          userId: data?.data?.userId || data?.userId || null,
          token: data?.data?.token || data?.token || null,
          url: data?.data?.url
            ? `${process.env.REACT_APP_SITE_URL || ''}${data.data.url}`
            : data?.url
            ? `${process.env.REACT_APP_SITE_URL || ''}${data.url}`
            : null,
        };
        setIsSuccessModalOpen(true);
        setJobResponseData(responseData);
        resetForm();
      })
      .catch((err) => {
        dispatch(hideLoading());
        dispatch(showModal(err.message));
        console.error('API Error:', err);
      });
  };

  const handleTabClick = (tabId) => {
    if (tabId === '1') {
      setActiveTab(tabId);
    }
  };

  const showTooltip = (message, event) => {
    const rect = event.target.getBoundingClientRect();
    let x = rect.left + rect.width / 2;
    let y = rect.top - 10;

    if (window.innerWidth <= 768) {
      x = window.innerWidth / 2;
      y = Math.max(30, rect.top - 10);
    }

    setTooltip({
      show: true,
      message,
      x,
      y,
    });

    if (tooltipTimeoutRef.current) {
      clearTimeout(tooltipTimeoutRef.current);
    }

    tooltipTimeoutRef.current = setTimeout(() => {
      setTooltip({ show: false, message: '', x: 0, y: 0 });
    }, 3000);
  };

  const hideTooltip = () => {
    if (tooltipTimeoutRef.current) {
      clearTimeout(tooltipTimeoutRef.current);
    }
    setTooltip({ show: false, message: '', x: 0, y: 0 });
  };

  return (
    <div
      className="service-tab overflow-hidden p-0"
      style={{ borderRadius: '10px', background: 'rgb(255 255 255 / 80%)' }}
    >
      <div className="d-flex shadow-sm">
        <Nav
          pills
          style={{ color: '#111', background: '#01a8af', display: 'flex' }}
          className="catagory-form"
        >
          <NavItem style={{ display: 'flex', flex: '1' }}>
            <NavLink
              style={{ color: '#ffff', width: '100%' }}
              active={activeTab === '1'}
              href="#"
              onClick={() => handleTabClick('1')}
            >
              Clearing
            </NavLink>
          </NavItem>
          <NavItem
            style={{ display: 'flex', flex: '1', cursor: 'not-allowed' }}
            title="Transport Service Currently Unavailable"
            ref={transportTabRef}
            onTouchStart={(e) => {
              showTooltip('Transport Service Currently Unavailable', e);
            }}
            onMouseEnter={(e) => {
              showTooltip('Transport Service Currently Unavailable', e);
            }}
            onMouseLeave={hideTooltip}
          >
            <NavLink
              style={{
                color: '#fff',
                width: '100%',
                cursor: 'not-allowed',
              }}
              active={activeTab === '2'}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                return false;
              }}
              disabled
              title="Transport Service Currently Unavailable"
            >
              Transport
            </NavLink>
          </NavItem>
          <NavItem
            style={{ display: 'flex', flex: '1', cursor: 'not-allowed' }}
            title="Both Service Currently Unavailable"
            ref={bothTabRef}
            onTouchStart={(e) => {
              showTooltip('Both Service Currently Unavailable', e);
            }}
            onMouseEnter={(e) => {
              showTooltip('Both Service Currently Unavailable', e);
            }}
            onMouseLeave={hideTooltip}
          >
            <NavLink
              style={{
                color: '#fff',
                width: '100%',
                cursor: 'not-allowed',
              }}
              active={activeTab === '3'}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                return false;
              }}
              disabled
              title="Both Service Currently Unavailable"
            >
              Both
            </NavLink>
          </NavItem>
        </Nav>
      </div>

      <div className="px-5 pt-3 pb-5">
        {activeTab === '1' && <ClearingServiceTab onSubmit={onSubmit} />}
        {activeTab === '2' && (
          <TransportServiceTab
            onSubmit={onSubmit}
            disabled
            title="Transport Service Currently Unavailable"
          />
        )}
        {activeTab === '3' && (
          <BothServiceTab onSubmit={onSubmit} disabled title="Both Service Currently Unavailable" />
        )}
      </div>

      {/* Custom Tooltip */}
      {tooltip.show && (
        <div
          className="custom-tooltip"
          style={{
            position: 'fixed',
            top: `${tooltip.y}px`,
            left: `${tooltip.x}px`,
            transform: 'translate(-50%, -100%)',
            backgroundColor: '#000',
            color: '#fff',
            padding: '5px 10px',
            borderRadius: '4px',
            fontSize: '14px',
            zIndex: 1000,
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
            maxWidth: '90vw',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {tooltip.message}
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              borderWidth: '5px',
              borderStyle: 'solid',
              borderColor: '#000 transparent transparent transparent',
            }}
          />
        </div>
      )}

      {isModalOpen && (
        <EmailOptVerifyModal
          isOpen={isModalOpen}
          toggle={() => setIsModalOpen(!isModalOpen)}
          email={values.email}
          onVerify={onOtpVerified}
        />
      )}

      {isSuccessModalOpen && (
        <JobSuccessModal
          isOpen={isSuccessModalOpen}
          toggle={() => setIsSuccessModalOpen(false)}
          onRefresh={() => window.location.reload()}
          jobResponseData={jobResponseData}
        />
      )}
      {/* Debug logs */}
      {console.log('JobSuccessModal rendering with jobResponseData:', jobResponseData)}
      {console.log('JobSuccessModal isOpen:', isSuccessModalOpen)}
    </div>
  );
};

export default ServiceCard;
